import { render, staticRenderFns } from "./JCP.vue?vue&type=template&id=c585ef96&"
import script from "./JCP.vue?vue&type=script&lang=js&"
export * from "./JCP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports